
import { APP_MENU_CONFIG } from './menuConfigs';
import LayoutBase from './LayoutBase';
import './layout.css';
import './layoutApp.css';

export const LayoutApp = () => (
  <LayoutBase 
    menuConfig={APP_MENU_CONFIG} 
    navClass="niogems-layout-nav niogems-layout-nav-app"
  />
);

export default LayoutApp;